export const constants = {
    APP_MESSAGE: {
      ACCOUNT_INFO_RETRIVE_ERROR: 'User not available',
      API_SAVE_ERROR: 'Some issue occurred while saving',
      API_RETRIVE_ERROR: 'Some issue occurred while retrieving data'
    },
    TURNAROUND_TEXT:{
      FURTURE_AND_PAST_SERIES:'After payment is received, transcript(s) will be sent within 14 days for past exam series. For future exam series, transcript(s) will be sent within 14 days after future results release after payment is received.',
      FUTURE_SERIES:'After payment has been received, your transcript(s) will be sent within 14 days after future results release.',
      PAST_SERIES:'Transcript(s) will be sent within 14 days after payment is received.'
      
    },
    EXAM_DETAILS:{
      EXAM_NAME:'AS & A Level exams and/or AICE Diploma',
      HELP_TEXT: 'Please be sure to add all exam series that you want to appear in this transcript. Once you submit this request, you cannot add exam series to it. Any new transcript requests will require an additional fee. You may add a future exam series starting approximately 3 months before the exam series is administered.'
    },
    reviewAndPay:{
      review: {},
      pay:{
        tc1:"Payment terms and conditions",
        tc2:"Please read and click to accept",
        need1: "Credit card (Mastercard, Visa, American Express)",
        need2: "Cardholder authorization (if under 18)",
        warning1: "You will be taken to a secure payment site.",
        warning2: "You have 48 hours to submit payment.",
        navToBarclay: "",
        urlKeys : ["ACCEPTURL","DECLINEURL","EXCEPTIONURL","CANCELURL","PSPID","SHAINPASSPHRASE","LOGO"]
      },
      barclay:{
        _shainpassphrase : "", 
        _pspid : "",                                       
        _orderid : "",
        _amount : "",
        _currency : "USD",                                            
        _language : "en_US",
        _title : "Grade Transcript Service",                         
        _bgcolor :"#f7f7f7",                                          
        _txtcolor : "#000000",                                          
        _tblbgcolor :"#ffffff",                                       
        _tbltxtcolor :"#000000",
        _buttonbgcolor :"#027BC1",                                    
        _buttontxtcolor :"#FFFFFF",
        _accepturl : "",
        _declineurl : "",
        _exceptionurl : "",
        _cancelurl : "",                                   
        _logo : "",         
        inputsArray : ["AMOUNT", "CURRENCY","LANGUAGE","ORDERID","PSPID","TITLE",
                            "BGCOLOR","TXTCOLOR","TBLBGCOLOR","TBLTXTCOLOR","BUTTONBGCOLOR", "BUTTONTXTCOLOR",
                            "LOGO","ACCEPTURL","DECLINEURL","EXCEPTIONURL","CANCELURL"]
      }
    },
    transcriptHistory:{
      headers:["Application submitted date","Payment due date","Payment date","Exam series","Order number","Status","Institution(s)",""],

      labels:{"header":"Transcript history","btn":"Send new transcript"},

      statuslabels:["inprogress",
                    "sent",
                    "refunded",
                    "authorisationdeclined",
                    "cancelled",
                    "cancelledbycustomer",
                    "notpaid",
                    "complete",
                    "completed",
                    "paymentrequired"],

      statusLinks:{"inprogress":"View summary",
                   "sent":"View summary",
                   "refunded":"View summary",
                   "authorisationdeclined":"Contact us",
                   "cancelled":"",
                   "cancelledbycustomer":"",
                   "notpaid":"Pay now",
                   "paymentrequired":"Pay now",
                   "complete":"View summary",
                   "completed":"View summary"},

      
      payNowLink:["notpaid","paymentrequired"],
      viewSummaryLink:["inprogress","sent","refunded","complete","completed"],
      viewScore:"View grades sent",
      availability:"(Available until",
      noData:"None available",
      future:"future",
      past:"past"
    },
    confirmation:{
      accepted:{msg1:"Your transcript request has been submitted",
                msg2:"Confirmation has been sent to the email address provided.",
                msg3:"Please keep this information for your records."},
      pendingOrReceived:{msg1:"Your payment request is under process,\n please check again in a few hours"}
    },
    modal:{
      scoresHeaders:['Series','Syllabus','Grade']
    },
    CREDITS_AND_RECOGNITION:{
      HEADER_LIST:{
        SUBJECT:'Subject',
        SYALLABUS_CODE:'Syllabus Code',
        QUALIFICATION_LEVEL:'Qualification Level',
        GRADE_MINIMUM:'Grade Minimum',
        COURSE_NAME:'Course Name',
        CREDIT_HOURS_AWARDED:'Credit Hours Awarded'
      },
      NO_CREDITS_MESSAGE:'This institution has not provided a credit table. Please contact the institution.',

      POLICY_PARSE:[/&lt;p&gt;/g,/&lt;\/p&gt;/g,/&lt;/g,/&lt;&gt;/g,/&gt;/g,/&lt;\/p/g,/&lt;\/a/g,/&lt;a/g,/&lt;p/g,/&amp;/g,/amp;/g,/&amp;bull;/g,/&amp;middot;/g,
                    /&amp;#39;/g,/&amp;rsquo;/g,/['",#]/g,/'/g,/’/g,/&#039;/g,/&quot;/g,/&nbsp;/g,

                    /<span style=&quot;font-family: arial, helvetica, sans-serif;&quot;&gt;/g,
                    /&amp;amp;/g,/<\/span&gt;<\/p&gt;/g,/&amp;nbsp;/g,/<strong&gt;/g,/<\/strong&gt;/g,
                    /<u&gt;/g,/<\/u&gt;/g,/<em&gt;/g,/<\/em&gt;/g,/<a href=&quot;/g,/<\/a&gt;/g,
                    /&quot;&gt;/g,/<span style=&quot;font-size:12px;/g,
                    /<span style=&quot;font-family:arial,helvetica,sans-serif;/g,
                    /<\/span&gt;/g,/<span style=&quot;font-size:11px;/g,/<\/p&gt;/g,
                    /don&amp;#39;t/g,/<ul&gt;/g,/<\/ul&gt;/g,/<li&gt;/g,/<\/li&gt;/g,
                    /style=&quot;margin-left:18.0pt;/g, /&quot; target=&quot;/g,/<br \/&gt;/g,
                    /=&quot;/g,/pl&quot;/g,/<ol&gt;/g,/<\/ol&gt;/g,/&amp;&rsquo/g,/&rsquo/g
                   ],

      POLICY_PARSE_REPLACE:[{key:/&amp;/g,val:"&"},
                            {key:/&amp;bull;/g,val:" * "},
                            {key:/&amp;middot;/g,val:" * "},
                            {key:/&#039;/g,val:"'"},
                            {key:/&quot;/g,val:'"'}]
  },
    deviceRegEx:/android|iphone|kindle|ipad/i,
    monthYearRegex:{
      month:/[a-zA-Z]+/g,
      year:/\d+/g
    },
    logout_urls:{
      otherEnv:'https://mycambridge.qa.internal.sso.cambridge.org/',
      uat:'https://mycambridge.prep.internal.sso.cambridge.org/',
      prod:'https://mycambridge.sso.cambridge.org/'
    }
};